import { useLocation } from "react-router-dom";

import { useIsDesktopApp } from "./MVVM/Hooks/useIsDesktopApp";
import { useIsMobileApp } from "./MVVM/Hooks/useIsMobileApp";

import { Sidebar } from "./MVVM/Components/Sidebar";
import { NavSignup } from "./components/organisms/navSignup";
import { MINIMAL_ROUTES } from "./routes/utils";
import { pathExcludesNavigation } from "./MVVM/Utilities/Navigation/utils";
import { useNewNav } from "./MVVM/Hooks/useNewNav";

const Navigation = () => {
  const { pathname } = useLocation();
  const isDesktopView = useIsDesktopApp();
  const isMobileApp = useIsMobileApp();
  const { newNav } = useNewNav();

  if (
    pathExcludesNavigation(pathname) ||
    isDesktopView.isDesktop ||
    isMobileApp.isMobileApp ||
    pathname.includes("mobile-app-link")
  )
    return <></>;

  if (MINIMAL_ROUTES.includes(pathname)) return <NavSignup />;

  // SiteNav owns the chrome for this cohort. LeftColumn has no width of its
  // own, so it collapses to zero.
  if (newNav) return <></>;

  return <Sidebar />;
};

export { Navigation };
